import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { ApiError, onSessionLost } from "./lib/api";
import { DemoProvider } from "./lib/demo";
import "./styles/tokens.css";
import "./styles/app.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Metryki zmieniają się raz na dobę (nocny przebieg), więc agresywne
      // odświeżanie przy każdym powrocie do zakładki tylko obciąża serwer.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

// Sesja wygasła i nie dała się odświeżyć: zamiast zostawiać użytkownika na
// stronie, na której każde zapytanie kończy się błędem, wracamy do logowania.
onSessionLost(() => {
  queryClient.cancelQueries();
  queryClient.setQueryData(["session"], null);
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <DemoProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </DemoProvider>
    </QueryClientProvider>
  </StrictMode>,
);
